module.exports = __webpack_public_path__ + "img/icon-remove-blue.2b010adc.svg";